// extracted by mini-css-extract-plugin
module.exports = {"sectionIndustry":"SectionIndustry_sectionIndustry_t6ZyI"};